import React from 'react';
import BaseSelect from 'react-select';

import { NestedUser, StudentTeamsDto } from '../../hooks/api/types';
import styled from '../../../../consts/styled';
import { usernameFullNameOrEmail } from '../../../../helpers/username';

const Select = styled(BaseSelect)`
  width: 300px;
`;

interface TeacherAssessmentProps {
  isGroupAssessment: boolean;
  studentTeams: StudentTeamsDto[];
  students: NestedUser[];
  setDisplayUserPk: (userId: string) => void;
}

const TeacherAssessment = (props: TeacherAssessmentProps) => {
  const { isGroupAssessment, studentTeams, students, setDisplayUserPk } = props;
  const selectOptions = isGroupAssessment
    ? studentTeams.map((team) => ({
        label: team.fields.name,
        value: team.fields.team_leader,
      }))
    : students.map((student) => ({
        label: usernameFullNameOrEmail(student),
        value: student.pk,
      }));
  return (
    <div>
      <p>Select user or team to display answers</p>
      <Select
        options={selectOptions}
        onChange={(option: any) => setDisplayUserPk(option.value as string)}
      />
    </div>
  );
};

export default TeacherAssessment;
